import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../common/custompagination";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import { getGatewayPaymentList } from "../../services/paymentManagement.services";

const GatewayPayments = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [datalength, setDataLength] = useState(0);
    const [itemperpage] = useState(10);
    const [page, setPage] = useState(parseInt(params.pgno) || 1);
    const [loader, setLoader] = useState(true);
    const [resetdate, setResetDate] = useState(false);
    const [globalsearch, setGlobalSearch] = useState("");
    const [search, setSearch] = useState({});

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Gateway Payments"), url: "" },
    ];

    useEffect(() => {
        const getData = setTimeout(() => {
            setLoader(true);
            const payload = {
                page: params.pgno || 1,
                per_page: itemperpage,
                global_search: globalsearch,
                ...search
            };

            getGatewayPaymentList(payload)
                .then((res) => {
                    if (res.success) {
                        setList(res.data.list || []);
                        setDataLength(res.data.total_records || 0);
                        setPage(res.data.page || 1);
                    }
                    setLoader(false);
                })
                .catch((error) => {
                    console.error(error);
                    setLoader(false);
                });
        }, 500);
        return () => clearTimeout(getData);
    }, [location, search, globalsearch, itemperpage, params.pgno]);

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        setSearch({});
        setResetDate(!resetdate);
    };

    const handleViewDetails = (id) => {
        navigate(`/admin/payment-management/view/payment/${id}`);
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">{t("Gateway Payments")}</h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent border-end-0">
                                            <i className="fa fa-search text-muted"></i>
                                        </span>
                                        <input
                                            type="search"
                                            className="form-control border-start-0 ps-0"
                                            value={globalsearch}
                                            placeholder={t("Search by Transaction ID...")}
                                            onChange={(e) => setGlobalSearch(e.target.value)}
                                        />
                                    </div>
                                </div>
                                {/* <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => setSearch({ ...search, start_date: e.start, end_date: e.end })}
                                        resetdate={resetdate}
                                    />
                                </div> */}
                                <button onClick={resetFilter} className="btn btn-warning">
                                    {t("btn_reset_filter")}
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th>{t("list_heading_sno")}</th>
                                        <th>{t("Transaction ID")}</th>
                                        <th>{t("User")}</th>
                                        <th>{t("Type")}</th>
                                        <th>{t("Method")}</th>
                                        <th>{t("Amount")}</th>
                                        <th>{t("Status")}</th>
                                        <th>{t("Created Date")}</th>
                                        <th>{t("Action")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr><td colSpan={8}><Loader /></td></tr>
                                    ) : list.length > 0 ? (
                                        list.map((row, i) => (
                                            <tr key={i}>
                                                <td>{((page - 1) * itemperpage) + i + 1}</td>
                                                <td className="fw-bold">{row.transaction_id}</td>
                                                <td>{row.user?.name || 'N/A'}</td>
                                                <td>{row.payment_type || 'N/A'}</td>
                                                <td className="text-uppercase">{row.payment_method}</td>
                                                <td>{row.currency_type === 'USD' ? '$' : '₹'}{parseFloat(row.amount).toFixed(2)}</td>
                                                <td>
                                                    <span className={`badge bg-${row.payment_status === 'success' ? 'success' : row.payment_status === 'pending' ? 'warning' : 'danger'}`}>
                                                        {row.payment_status}
                                                    </span>
                                                </td>
                                                <td>{row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                                                <td>
                                                    <button
                                                        className="btn ripple btn-main-primary signbtn"
                                                        onClick={() => handleViewDetails(row.id)}
                                                    >
                                                        {t("btn_view")}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr><td colSpan={8} className="text-center">{t("msg_no_records")}</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3">
                            <b>{t("msg_total_records")} : {datalength}</b>
                        </div>

                        {datalength > 0 && (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                currentPage={page}
                                setPage={(p) => navigate(`/admin/payment-management/gateway-payments/${p}`)}
                                pageRoute={[{ name: "Gateway Payments", path: "/admin/payment-management/gateway-payments" }]}
                            />
                        )}
                    </div>
                </div>
            </div>

        </>
    );
};

export default GatewayPayments;
